import { Pipe, PipeTransform } from "@angular/core";
import { ShareTypeUnit } from "../interfaces";

@Pipe({
  name: 'shareTypeUnits',
})
export class ShareTypeUnitsPipe implements PipeTransform {
  transform(value: number, units: ShareTypeUnit): string {
    return units === "Percent"
      ? `${ value / 100 }%`
      : `${ value } Units`
  }
}
